export default __webpack_public_path__ + "static/media/audio5_leg.dee9fe3a.m4a";